import {
  BilletsStatus,
  ListBillets,
} from '@/core/domain/financial/Boletos/Boletos.types';
import { Alert, Divider, Form, Modal, ModalProps } from 'antd';
import moment from 'moment';

import { useEffect } from 'react';
import BankSlipViewModalForm from './BankSlipViewModalForm';

type Props = Omit<ModalProps, 'onCancel'> & {
  onCancel: () => void;
  selectedBankSlip?: ListBillets;
};

export default function BankSlipViewModal({
  open,
  onCancel,
  selectedBankSlip,
}: Props) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (selectedBankSlip) {
      form.setFieldsValue({
        ...selectedBankSlip,
        createdAt: selectedBankSlip.createdAt
          ? moment(selectedBankSlip.createdAt)
          : '',
        dueDate: selectedBankSlip.dueDate
          ? moment(selectedBankSlip.dueDate)
          : '',
        liquidationDate: selectedBankSlip.billLiquidationDate
          ? moment(selectedBankSlip.billLiquidationDate)
          : '',
        cancelDate: selectedBankSlip.billRejectDate
          ? moment(selectedBankSlip.billRejectDate)
          : '',
        dischargeDate: selectedBankSlip.billDoneDate
          ? moment(selectedBankSlip.billDoneDate)
          : '',
        ourNumber:
          selectedBankSlip?.ourNumber?.toString().length > 8
            ? selectedBankSlip?.ourNumber
                .toString()
                .replace(
                  selectedBankSlip.ourNumber?.toString()[1],
                  selectedBankSlip.ourNumber?.toString()[1] + '-',
                )
            : selectedBankSlip?.ourNumber,
        companyId: Number(selectedBankSlip.companyId),
        bankAccountId: Number(selectedBankSlip.bankAccountId),
      });
    }
  }, [open]);

  return (
    <Modal
      width={1000}
      open={open}
      onCancel={onCancel}
      title={`Detalhes do boleto - Id Integração: #${selectedBankSlip?.integrationId} - Cliente: ${selectedBankSlip?.debtor}`}
      cancelText="Fechar"
      okButtonProps={{ hidden: true }}
    >
      <BankSlipViewModalForm form={form} selectedBankSlip={selectedBankSlip} />

      {(selectedBankSlip?.status === BilletsStatus.failed ||
        selectedBankSlip?.status === BilletsStatus.rejected) && (
        <>
          <Divider />

          <Alert
            showIcon={!selectedBankSlip?.motive}
            type="error"
            message={
              selectedBankSlip?.motive
                ? 'Boleto com falha/rejeitado'
                : 'Motivo da falha não identificado.'
            }
            description={
              selectedBankSlip?.motive ? selectedBankSlip.motive : undefined
            }
          />
        </>
      )}
    </Modal>
  );
}
